/* eslint-disable no-underscore-dangle */
import { Injectable } from '@angular/core';
import { Info } from '../../constant/information.const';

/**
 *
 * Cryptor Service
 * @ class StorageWrapperService
 */
@Injectable({ providedIn: 'root' })
export class StorageWrapperService {
  /** Cache instance of storage */
  private readonly _cache = {};

  public clearAll(): void {
    sessionStorage.clear();
  }

  public clearCache(): void {
    const keys = Object.keys(this._cache);
    keys.forEach((key) => {
      delete this._cache[key];
    });
  }

  public get<T>(key: string): T {
    if (this._cache[key]) {
      return this._cache[key];
    }

    const value = sessionStorage.getItem(key);
    if (!value || typeof value !== Info.string || value === '') {
      return undefined;
    }

    // try / catch added to handle parse error on encrypted (old) localstorage values
    try {
      this._cache[key] = JSON.parse(value) as T;
    } catch {
      sessionStorage.removeItem(key);
      return undefined;
    }
    return this._cache[key];
  }

  public length(): number {
    return sessionStorage.length;
  }

  public remove(...keys: string[]): boolean {
    try {
      keys.forEach((key) => {
        sessionStorage.removeItem(key);
        delete this._cache[key];
      });
    } catch (error) {
      return false;
    }
    return true;
  }

  public set(key: string, value): boolean {
    const tempValue = JSON.stringify(value);
    sessionStorage[key] = tempValue;
    delete this._cache[key];
    return true;
  }
}
